import {
  ActivityObject,
  ActivitiesResponse,
} from './../layout/Inbox/InboxInterfaces/activityObject';
import { Internal } from './../layout/Inbox/InboxInterfaces/newEmail';
import {
  InboxParams,
  InboxResponse,
} from './../layout/Inbox/InboxInterfaces/inboxParams';
import { InboxObject } from './../layout/Inbox/InboxInterfaces/InboxFolder';
import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { MessageDetail } from '../layout/Inbox/InboxInterfaces/messageDetail';
import * as g from 'src/app/globals';

@Injectable({
  providedIn: 'root',
})
export class InboxService {
  updateInboxEmitter: EventEmitter<any> = new EventEmitter();
  updateUnreadMessagesEmmiter: EventEmitter<any> = new EventEmitter();
  constructor(private http: HttpClient) {
  }
  //#region share message details id between components
  private messageIdSource = new BehaviorSubject('111');
  currentMessageId = this.messageIdSource.asObservable();

  changeMessageId(messageId: string) {
    this.messageIdSource.next(messageId);
  }
  //#endregion



  //#endregion

  getInboxFolders(): Observable<InboxObject> {
    return this.http.get<InboxObject>(g.apiBaseUrl + 'apiInbox/InboxFolders');
  }

  getInbox(
    inboxParams: InboxParams,
    folder?: string
  ): Observable<InboxResponse> {
    return this.http.post<InboxResponse>(
      g.apiBaseUrl + 'apiInbox/InboxListAjax',
      { param: inboxParams, folder }
    );
  }

  getUnreadMessages(): Observable<InboxResponse> {
    return this.http.get<InboxResponse>(
      g.apiBaseUrl + 'apiInbox/GetUnreadMessages'
    );
  }

  getMessageDetail(selectedId: number): Observable<MessageDetail> {
    return this.http.get<MessageDetail>(
      g.apiBaseUrl + 'apiInbox/InboxMsg/?selectedId=' +
      selectedId
    );
  }

  StarringMessage(selectedId: string, status: string): Observable<any> {
    if (status === 'Y') {
      return this.http.post(
        g.apiBaseUrl + 'apiInbox/ChangeMSGFlag',
        { selectedId, new_status: 'N' }
      );
    } else {
      return this.http.post(
        g.apiBaseUrl + 'apiInbox/ChangeMSGFlag',
        { selectedId, new_status: 'Y' }
      );
    }
  }

  DeleteMessage(MessageId: string): Observable<any> {
    return this.http.post(g.apiBaseUrl + 'apiInbox/MoveMsgs', {
      MsgsToMove: MessageId,
      folder: '-1',
    });
  }

  MoveMessageToFolder(MessageId: string, folderCode: string): Observable<any> {
    return this.http.post(g.apiBaseUrl + 'apiInbox/MoveMsgs', {
      MsgsToMove: MessageId,
      folder: folderCode,
    });
  }

  getListOfEmails(): Observable<any> {
    const frmData = new FormData();
    frmData.append('queryId', '2301');
    frmData.append('addTerm', 'true');
    frmData.append('search', '');
    return this.http.post(
      g.apiBaseUrl + 'Report/ParameterDataSource',
      frmData
    );
  }

  getInternals(): Observable<Internal> {
    return this.http.get<Internal>(
      g.apiBaseUrl + 'apiInbox/getInternals'
    );
  }

  SendNewEmail(emailFormData: any): Observable<any> {
    return this.http.post(
      g.apiBaseUrl + 'apiInbox/InboxSendDraft',
      emailFormData
    );
  }

  createNewFolder(folderName: string): Observable<any> {
    const folderFormData = new FormData();
    folderFormData.append('FolderName', folderName);
    return this.http.post(
      g.apiBaseUrl + 'apiInbox/CreateFolder',
      folderFormData
    );
  }

  getOrginalMessageForReply(replyCode: string): Observable<any> {
    return this.http.post(g.apiBaseUrl + 'apiInbox/InboxNew', {
      replyCode,
    });
  }

  changeApprovalStatus(
    WddCode: number,
    Status: string,
    Remarks: string
  ): Observable<any> {
    return this.http.post(
      g.apiBaseUrl + 'apiInbox/ChangeApprovalStatus',
      {
        WddCode,
        Status,
        Remarks,
      }
    );
  }

  getActivities(): Observable<ActivitiesResponse> {
    return this.http.get<ActivitiesResponse>(
      g.apiBaseUrl + 'apiInbox/GetActivitis'
    );
  }

  getActivityById(id: string): Observable<ActivitiesResponse> {
    return this.http.get<ActivitiesResponse>(
      g.apiBaseUrl + 'apiInbox/GetActivity?id=' + id
    );
  }

  getBusinessPartner(id: string): Observable<any> {
    return this.http.get(
      g.apiBaseUrl + 'apiInbox/GetBusinessPartnerById?id=' + id
    );
  }
}
